import { companyApis } from '@apis/dashboard/companyApis';
import { createUseQuery } from '@hooks/createUseQuery';
import { DashboardCompanyQuery } from '@models/Company';

export const useCompanyItemList = createUseQuery(
  (query: DashboardCompanyQuery) => ['/dashboard/company/', query],
  (query) => () =>
    companyApis
      .get('/dashboard/company/', {
        query,
      })
      .then((r) => r[200]!),
);
